import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService, Referral } from 'src/app/core';

@Component({
  selector: 'app-referral-code',
  templateUrl: './referral-code.component.html',
  styleUrls: ['./referral-code.component.scss'],
})
export class ReferralCodeComponent implements OnInit {
  public referral!: Referral;

  constructor(
    private activatedRouter: ActivatedRoute,
    private configService: ConfigService,
    private snackbar: MatSnackBar
  ) {
    this.activatedRouter.data.subscribe((data) => {
      if (data['referral']) {
        this.referral = data['referral'];
      }
    });
  }

  ngOnInit(): void {}

  public get url() {
    return (
      this.configService.getFrontendBaseUrl() +
      '?referral=' +
      this.referral.code
    );
  }

  public copyToClipboard() {
    navigator.clipboard.writeText(this.url);
    this.snackbar.open('لینک کپی شد');
  }
}
